export type SmsSenderFn = (to: string[], text: string) => Promise<any>;

export enum SmsRelayType {
  EXTERNAL_API = 'EXTERNAL_API',
  DEVICE = 'DEVICE',
}

export type SmsProvider = {
  id: string,
  name: string,
  description?: string,
  relayType: SmsRelayType,
  enabled: boolean,
};

export type SmsMessage = {
  to: string;
  message: string;
};

export const SMS_VARIABLE_MY_CLUB_URL_PREFIX_KEY = 'myClubUrlPrefix';
